import { render, staticRenderFns } from "./PasswordCreationForm.vue?vue&type=template&id=30f60c12&scoped=true&lang=pug&"
import script from "./PasswordCreationForm.vue?vue&type=script&lang=js&"
export * from "./PasswordCreationForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordCreationForm.vue?vue&type=style&index=0&id=30f60c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f60c12",
  null
  
)

export default component.exports